import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  getChild(data) {
    const { childId, childEditionRetentionHash, isRetention } = data
    if (isRetention && childEditionRetentionHash) {
      return http.get(
        endpoints.get('childHashRetention', {
          childId,
          childEditionRetentionHash
        })
      )
    }
    const endpointLabel = isRetention ? 'childRetention' : 'child'
    return http.get(endpoints.get(endpointLabel, { childId }))
  }
}
